module.exports = __webpack_public_path__ + "img/planning_sheets.95bb58c6.svg";